<template>
  <!-- 失败提示 -->
    <div id="warnToast">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{txtrro}}</p>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    txtrro: String
  },
}
</script>
